export const getColorIdByOrder = (order:number):number => {
	return (order % 9) + 1;
};